import { atom, type Atom } from "jotai"
import { atomWithStorage } from "jotai/utils"
import type { UserDocument, VMModel } from "@hooks/type-ds"
import { defaultState, type State } from "./defaultReducerState"
//import { type Modals } from '@store/modal.config'
import type { RichiestaInsert } from '@store/defaultReducerState'
import type { AnalyticsAction } from "@ui/components/analytics"
import type { EntryMode } from "@ui/richiesta/stepper/data/steps"
import type { UploadMode } from "@ui/richiesta/pages/thank-you/UploadDocumentsModal"
import { isDeviceMobile } from "@utils/mobile"


// ==========================
//  STATE PRINCIPALE RICHIESTA
// ==========================


export const dataStateAtom = atom<State>(defaultState) //state generale interno usato SOLO DA SIMULATORE AL MOMENTO VERIFIC SE SPOSTARRLO IN STORE


export const initialVMState: VMModel = {
  Provenienza: '',
  IdRichiesta: 0,
  currentStep: 1,
  isModify: false,
  isLanding: false,
  blockedSelectedSond: false,
  sessione: '',
  OTPGenerated: null,
  cfChecked: null,
  checkCFcustom: null,
  codiceCliente: null,
  serviceDown: false,
  verifyOTP: false,
  Step4SelectedPartialViews: null,
  Thanks: { done: false },
  StartingValues: {
    CodiceAffinity: '',
    Broker: null,
    ProductType: null,
    Product: null,
    FinancialTable: null,
    Amount: '',
    InstallmentsNumber: null,
    InstallmentAmount: '',
    Token: null,
    oGUID: null,
  },
  One: {
    Amount: '',
    MotivationSelected: '',
    Insurance: false,
    InsuranceComparatore: false,
    Installments: [],
    SelectedInstallment: {},
    CocalfinID: 0,
    FinancialTable: '',
    Prodotto: '',
    TipoProdotto: '',
    Emettitore: '',
    Provenienza: '',
    IdentinetEnabled: false,
    IsSecciVisible: false,
  },
  Two: {
    FiscalCode: '',
    FiscalCodeCountry: null,
    Name: '',
    Surname: '',
    IP: '',
    BirthDate: '',
    BirthState: '',
    BirthStateId: '',
    BirthLocation: '',
    BirthLocationId: '',
    Gender: '',
    Marketing: false,
    Profilazione: false,
    MarketingGBCI: false,
    Third: false,
    Privacy: false,
    Sensible: false,
    PEP: false,
    PhoneNumber: '',
    CellNumber: '',
    Email: '',
    ConfirmEmail: '',
    Session: null,
  },
  Three: {
    Citizenship: '',
    CitizenshipType: '',
    CitizenshipExpire: '',
    MaritalState: '',
    HomeType: '',
    RentAmount: '',
    CurrentAddress: {
      Address: '',
      AddressNumber: '',
      CAP: '',
      Comune: '',
      ComuneLabel: '',
      Provincia: '',
      ProvinciaLabel: '',
    },
    PrecAddress: {
      Address: '',
      AddressNumber: '',
      CAP: '',
      Comune: '',
      ComuneLabel: '',
      Provincia: '',
      ProvinciaLabel: '',
    },
    ResidentFrom: '',
    ResidentMonthFrom: '',
    ResidentYearFrom: '',
    Document: {
      DocumentType: '',
      Serial: '',
      DateOfIssue: '',
      IssuingPlace: '',
      Address: {
        Address: '',
        AddressNumber: '',
        CAP: '',
        Comune: '',
        ComuneLabel: '',
        Provincia: '',
        ProvinciaLabel: '',
      },
    },
  },
  Four: {
    Activity: '',
    Occupation: '',
    ActivityStartDate: '',
    ActivityEndDate: '',
    ActivityStartMonth: '',
    ActivityEndMonth: '',
    ActivityStartYear: '',
    ActivityEndYear: '',
    ActivitySector: '',
    NetMonthlyIncome: '',
    ContractType: '',
    Monthly: '',
    CompanyName: '',
    CompanyAddress: {
      Address: '',
      AddressNumber: '',
      CAP: '',
      Comune: '',
      ComuneLabel: '',
      Provincia: '',
      ProvinciaLabel: '',
    },
    CompanyPhone: '',
    CorrentistaBCC: false,
    IBAN: '',
    PEP: false,
  },
  Seven: {
    IdSondaggio: 0,
    InstallmentsSond: [],
    SelectedInstallmentSond: {
      InstallmentsCount: 0,
      Amount: 0,
      Tan: 0,
      Taeg: 0,
      PrgSimul: 0,
      Erogato: 0,
      FinanziamLordo: 0,
      ImpServiziFinanz: 0,
      ImpServiziIdentinet: 0,
    },
    Sondaggio: [],
    nSelectedInstallmentSond: 0,
    MotivationSelected: null,
    SondSelected: false,
    SondApprovato: false,
    SondRisposte: '',
    Beneficiario: false,
    BenName: '',
    BenSurname: '',
    BenFiscalCode: '',
    BenRelazCli: '',
    BenCellNumber: '',
    BenEmail: '',
    BenAddress: {
      Address: '',
      AddressNumber: '',
      CAP: '',
      Comune: '',
      ComuneLabel: '',
      Provincia: '',
      ProvinciaLabel: '',
    },
    BenBirthDate: null,
    BenBirthState: null,
    BenBirthStateId: null,
    BenBirthLocation: null,
    BenBirthLocationId: null,
    BenGender: null,
    BenEsclCom: false,
    UltPreferenze: false,
    UltPrfFiscalCode: '',
    UltPrfName: '',
    UltPrfSurname: '',
    UltPrfCellNumber: '',
    UltPrfEmail: '',
    UltPrfAddress: {
      Address: '',
      AddressNumber: '',
      CAP: '',
      Comune: '',
      ComuneLabel: '',
      Provincia: '',
      ProvinciaLabel: '',
    },
    UltPrfBirthDate: null,
    UltPrfBirthState: null,
    UltPrfBirthStateId: null,
    UltPrfBirthLocation: null,
    UltPrfBirthLocationId: null,
    UltPrfGender: null,
    CompletSondaggio: false,
    BenPhoneNumber: '',
    UltPrfPhoneNumber: '',
    IdentinetActive: false,
    IdentinetContractDuration: null,
  },
}

export const dataStateVmAtom = atom<VMModel>(initialVMState) //staet model


// Stato servizi (equivalente a state.servizi)
export const serviziAtom = atom({
  insurance: false,
  beneficiaryEscComm: false,
  validSurvey: false,
  heir: false,
  thirdParty: false,
  identinetActive: false,
  identinetContractDuration: "",
})

//------------------------------------------------
// CURRENT STEP DELLA RICHIESTA USARE NECESSARIAMENTE QUESTO VALORE 
//--------------------------------------------------
export const currentStepAtom = atom<number>(0) //DEFAULT VALUE = 0 

//selected radio button SUBSTEP -- ES CONTACT-> 1- FOTOGRAFA, 2 -ALLEGA, 3 -MANUALMENTE
export const selectedValueAtom = atom<Record<number, string>>({})

export const currentContactPageAtom = atom<string | null>(null)    // pagina interna da mostrare

//////////////////////////////
// Substep → stringa (valore selezionato del substep)

///COMPONENTE DEL SUBSTEP es "selectDocument"
export const DEFAULT_SUBSTEP=null;
export const selectedSubStepAtom =atom<string | null>(DEFAULT_SUBSTEP) 

//// SUBSTEPS INTERNI 
export const subStepValuesAtom = atom<Record<string, any>>({});
// es: { "1-2": { radio: "A" } } 


export const showSubStepAtom = atom<Record<number, boolean>>({})

// SubStepExists → booleano (true se la categoria selezionata ha substeps)
export const subStepExistsAtom = atom<boolean>(false)

export const selectedSubStepIndexAtom = atom<number | null>(null)

//ATOM PER GESTIRE ABILITAZIONE BUTTON PROSEGUI
export const _isDisabledValueAtom = atom(false)

// atom pubblico (stesso nome di prima)
export const isDisabledValueAtom = atom(
  (get) => get(_isDisabledValueAtom),
  (_get, set, next: boolean) => {
  //  console.log('isDisabledValueAtom SET →', next)
    //console.trace('who called isDisabledValueAtom')
    set(_isDisabledValueAtom, next)
  }
)

 
export const isDisabledAtom = atom(

  (get) => get(isDisabledValueAtom),
  (_get, set, next: boolean) => {
   // console.log('[isDisabledAtom] ->', next)
   // console.trace('[isDisabledAtom] stack') // CHI scrive
    set(isDisabledValueAtom, next)
  }
) 


//gestione submit form salvo una funzione di sunbit e la richiamo dal footer

export const submitStepAtom = atom<null | (() => void)>(null)

//////////////////////

// Stato UI (ex reducer UI flags)
export const uiProgressBarAtom = atom(true)

// Identinet duration (azione nel reducer)
export const contractDurationAtom = atom<string>("")

// Contatore fetch silenziose
export const silentFetches = atom(0)

// Sessione BE
export const sessioneAtom = atom<string | null>(null)

// Token mobile
export const mobileTokenAtom = atom<string | null>(null)

//CODICE FISCALE ERROR
export const fiscalCodeErrorAtom = atom<boolean>(false)


// === CF INFOS ===
export const userCFInfosAtom = atom({
  Gender: '',
  BirthDate: '',
  BirthLocation: '',
  BirthLocationId: '',
  BirthState: '',
  BirthStateId: '',
  CellNumber: '',
})

// === UI / FLOW ===
/* export const richiestaAtom = atom<RichiestaInsert>('MANUAL')
export const otpAtom = atom(false)
export const appErrorAtom = atom(false)
 */

//const action = 'none' //ADD 4.1 SET none as default not Step01, assigned by landing ora step1
export const userPhoneNumber = atom('')

// ======================================================
//  ACTIONS (equivalente dei “case ...” nel reducer)
// ======================================================

// Aggiorna intero nodo dataState.data
export const updateDataAtom = atom(
  null,
  (get, set, payload: Partial<State>) => {
    const prev = get(dataStateAtom)
    set(dataStateAtom, {
      ...prev,      // merge delle proprietà esistenti
      ...payload,   // sovrascrive solo le proprietà passate
    })
  }
)

// Aggiorna lo step corrente
export const updateStepAtom = atom(
  null,
  (get, set, newStep: number) => {
    set(currentStepAtom, newStep)
  }
)

// Mostra/Nasconde progress bar UI
export const uiProgressBarActionAtom = atom(
  null,
  (get, set, visible: boolean) => {
    set(uiProgressBarAtom, visible)
  }
)

// Aggiorna contract duration Identinet
export const updateContractDurationAtom = atom(
  null,
  (get, set, duration: string) => {
    set(contractDurationAtom, duration)
  }
)

// Aggiorna servizi (equivalente state.servizi.*)
export const updateServiziAtom = atom(
  null,
  (get, set, patch: Partial<typeof serviziAtom extends Atom<infer T> ? T : never>) => {
    const prev = get(serviziAtom)
    set(serviziAtom, {
      ...prev,
      ...patch,
    })
  }
)

////////////////

const action = 'none' //ADD 4.1 SET none as default not Step01, assigned by landing ora step1

export const analyticsCurrentAction = atom<AnalyticsAction>(action)
export const hideStepper = atom(false)


export const fiscalCodeError = atom({
	FiscalCode: false,
	BenFiscalCode: false,
	UltPrfFiscalCode: false,
})

export const hasUserUploadedDocuments = atom(false)
export const showMobileUploadThankYou = atom(false)

// Tipi delle modali disponibili
export type Modals =
  | 'Richiesta_CARTA-ID'
  | 'DEFAULT'

// Stato della modale

export type ModalState = {
  isOpen: boolean;
	onCloseModal?: () => void
  type?: Modals;
  title?: string;
  labelOk?: string | null;
  reverseButton?:boolean,
  labelClose?: string | null;
  disableButton?: boolean;
  disableButtonAdd?:boolean;
  hideClose?:boolean;
  hideBorderLeft?:boolean;
  modalSpacingFromTop?: string;
  height?:string;
  width?:string;
  spreadButtons?:boolean;
  onCallBack?: () => void;
  loading?:boolean;
  children?: React.ReactNode | (() => React.ReactNode)  
  buttonLoading?: boolean
}

// Atom principale per lo stato della modale
export const modalAtom = atom<ModalState>({
  isOpen: false,
  type: "DEFAULT",
  title: '',
  labelOk: null,
  labelClose: null,
  disableButton: false,
  onCallBack: undefined,
	onCloseModal: undefined,
  children: undefined,
})


///usato per la gesitone della visibilità della modale 
export const modalShowHeader = atom(true)


export type UpdateFilesPayload = {
  name: UserDocument
  files: File[]
}

export const updateFilesAtom = atom(
  null,
  (get, set, payload: UpdateFilesPayload) => {
    const state = get(dataStateAtom)
    set(dataStateAtom, {
      ...state,
      files: {
        ...state.files,
        [payload.name]: payload.files,
      },
    })
  }
)



///upload document
 type Side = "front" | "back" | "success"

export interface FilesState {
  front: File | null
  back: File | null
  success:File | null
}
 
export interface PreviewState {
  side: Side
  src: string
  file: File
} 



// Stato dei file caricati
export const filesAtom = atom<Record<number, FilesState>>({});
//export const filesAtom = atom<FilesState>({ front: null, back: null })

// Stato della preview attiva
export const previewAtom = atom<PreviewState | null>(null)

// Numero di pagine PDF nella preview
export const numPagesAtom = atom<number>(0)

/* export const canProceedAtom = atom((get) => {
  const files = get(filesAtom)
  return !!files.front && !!files.back
})
 */

////////////////////----------------old vlaue


export type PlaceInfos = {
	ABI: string
	CAB: string
	Luogo: string
	Nome: string
}

export type OptionType = {
	code: string
	label: string
}


type Comuni = {
	fatherCode: string
	label: string
	code: string
}

type AllPlaces = {
	Primary: OptionType
	List: Comuni[]
}

export const rateHasError = atom(false)
export const yupContext = atom<Record<string, unknown>>({})

export const useWorkplace = atom(false)

export const showAffinityError = atom(false)

export const banks = atom<Record<string, Array<PlaceInfos>>>({})
export const places = atom<Array<AllPlaces>>([])

hideStepper.debugLabel = 'showStepper'
fiscalCodeError.debugLabel = 'fiscalCodeError'
userPhoneNumber.debugLabel = 'userPhoneNumber'
modalShowHeader.debugLabel = 'modalShowCloseButton'
hasUserUploadedDocuments.debugLabel = 'hasUserUploadedDocuments'
rateHasError.debugLabel = 'rateHasError'
useWorkplace.debugLabel = 'useWorkplace'
analyticsCurrentAction.debugLabel = 'analyticsCurrentAction'
showAffinityError.debugLabel = 'showAffinityError'
//navigatore

export const entryModeAtom = atom<EntryMode | null>(null)


export const documentFlowVariantAtom = atom('')

export const qrDisclaimerAtom = atom(false)


/**
 * Set to true by useQR when a QR-based upload completes in the MissingDocuments
 * flow. MissingDocuments watches this to trigger the FPgesudo notification.
 */
export const qrMissingDocsCompletedAtom = atom(false)

/**
 * Tracks which completion variant the user triggered on the MissingDocuments page.
 * 'done'    → all documents uploaded, user clicked Prosegui
 * 'missing' → user clicked Carica in seguito
 * null      → not yet set
 * Persisted to sessionStorage so a hard refresh keeps the user on the thank-you page.
 */
export const completedPageVariantAtom = atomWithStorage<'done' | 'missing' | null>(
  'missingDocs_completedVariant',
  null,
  undefined,
  { getOnInit: true }
)

/**
 * Snapshot of uploaded document types captured when the user leaves MissingDocuments.
 * Used by MissingDocsThankYouPage to compute the right subtitle without re-fetching.
 * Persisted to sessionStorage alongside the variant.
 */
export const completedPageUploadedDocsAtom = atomWithStorage<UserDocument[] | null>(
  'missingDocs_uploadedDocs',
  null,
  undefined,
  { getOnInit: true }
)

/**
 * Snapshot of context-dependent fields needed by MissingDocsThankYouPage.
 * Captured in MissingDocuments before navigating so the thank-you page has
 * the correct values even after a hard refresh.
 *
 * activity:      Four.Activity  ('D' | 'T' | 'A' | 'P' | 'X' | '')
 * iban:          Four.IBAN
 * documentType:  Three.Document.DocumentType  (e.g. 'PAT' | 'CI')
 */
export const completedPageContextDataAtom = atomWithStorage<{
  activity: string
  iban: string
  documentType: string
} | null>(
  'missingDocs_contextData',
  null,
  undefined,
  { getOnInit: true }
)


///SERVICE 

export const mainChoiceAtom = atom<'si' | 'no' | null>(null)
export const identinetChoiceAtom = atom<'yes' | 'no' | null>(null)


///OTP LANDING SHOW 

export const otpLandingShowAtom = atom(true)

//docuento fiscale upoload
export type MultiUploadItem = {
  id: string
  file: File | null
}

export const multiFilesAtom = atom<Record<number, MultiUploadItem[]>>({})
//used from know iffiscal document is in preview 
export const multiFilePreviewAtom = atom(false)

//gestione DISCLAIMER 
export const selectedSondInstallmentAtom = atom<any | null>(null)

//-------------missingDocuments Upload 
export const selectedMissingDocumentAtom =
	atom<UserDocument | null>(null)


  export const selectedUploadModeAtom = atom<UploadMode | null>(
	isDeviceMobile() ? 'camera' : null
)